import { useMutation } from '@tanstack/react-query'

import { SubmitIssueReportReq } from '~shared/dto'

import { api } from '~lib/api'

export const useSubmitIssueReport = ({ eventId }: { eventId: string }) => {
  return useMutation((body: SubmitIssueReportReq) =>
    api.url(`/events/${eventId}/issue-reports`).post(body).res(),
  )
}
